import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref } from '../../../../adapter-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'message-location',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props


const data = ref();
watchEffect(() => {
  data.value = props.content;
});

return { __sfc: true,props, data }
}

})